<template>
  <div class="popup" id="popup">
    <div class="popup__content popup--animate">
      <div class="popup__header">
        <svg class="popup__icon">
          <use href="@/assets/sprite.svg#icon-group"></use>
        </svg>
        <h1 class="heading-tertiary">{{ $t('popup.groupAbility.setUsers.title') }}</h1>
      </div>
      <div class='popup__form'>
        <form @submit.prevent="setUsers" class="form" id="setUsersForm">
          <span class="userpopup__roles-label u-margin-bottom-tiny">{{ $t('popup.groupAbility.setUsers.userLabel', { name: role.name }) }}</span>
          <div class="form__grouprow userpopup__roles-list">
            <div class="form__group u-margin-left-medium">
              <div class="userpopup__roles">
                <div v-for="(user, index) in usersList" :key="user._id">
                  <div v-if="index < offset">
                    <input class="userpopup__checkbox-button" type="checkbox" :value="user._id" :id="index" v-model="user.checked">
                    <label class="userpopup__checkbox-label u-pointer" :for="index">{{ user.firstname }} {{ user.name }}</label>
                  </div>
                </div>
                <!-- <div v-for="i in offset" :key="i">
                  <input class="userpopup__checkbox-button u-pointer" type="checkbox" :value="usersList[i-1]._id" :id="i-1" v-model="usersList[i-1].checked">
                  <label class="userpopup__checkbox-label u-pointer" :for="i-1">{{ usersList[i-1].firstname }} {{ usersList[i-1].name }}</label>
                </div> -->
              </div>
            </div>
            <div class="form__group u-margin-left-medium">
              <div class="userpopup__roles">
                <div v-for="(user, index) in usersList" :key="user._id">
                  <div v-if="index >= offset">
                    <input class="userpopup__checkbox-button" type="checkbox" :value="user._id" :id="index" v-model="user.checked">
                    <label class="userpopup__checkbox-label u-pointer" :for="index">{{ user.firstname }} {{ user.name }}</label>
                  </div>
                </div>
                <!-- <div v-for="i in usersList.length-offset" :key="i+offset">
                  <input class="userpopup__checkbox-button u-pointer" type="checkbox" :value="usersList[i-1+offset]._id" :id="i-1+offset" v-model="usersList[i-1+offset].checked">
                  <label class="userpopup__checkbox-label u-pointer" :for="i-1+offset">{{ usersList[i-1+offset].firstname }} {{ usersList[i-1+offset].name }}</label>
                </div> -->
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="popup__footer">
        <button class="popup__link u-pointer" type="button" form="setUsersForm" @click='close'>{{ $t('popup.groupAbility.setUsers.cancelAction') }}</button>
        <button class="popup__link u-pointer" type="submit" form="setUsersForm">{{ $t('popup.groupAbility.setUsers.confirmAction') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CLIENT } from '@/axios-wrapper'
import { formMixin } from '@/components/Mixins/Form'
import { toastMixin } from '@/components/Mixins/Toast'

const NB_MAX_ROLES_VISIBLE = 9

export default {
  data: function () {
    return {
      usersList: [],
      offset: NB_MAX_ROLES_VISIBLE
    }
  },
  mixins: [formMixin, toastMixin],
  props: ['role'],
  mounted () {
    this.getUsers()
  },
  methods: {
    async getUsers () {
      try {
        let { data } = await HTTP_CLIENT.get(`user?sort=firstname`)
        this.usersList = data
        this.usersList.forEach(user => {
          user.checked = user.default = false
          if (user.groupAbilities.includes(this.role._id)) {
            user.checked = user.default = true
          }
        })

        if (this.usersList.length > NB_MAX_ROLES_VISIBLE * 2) {
          this.offset = Math.trunc(this.usersList.length / 2)
        }
      } catch (error) { console.log(error) }
    },
    close () {
      this.$emit('popup:close')
      this.$store.commit('groupAbility/SHOW_SETUSERS_GROUPABILITY_POPUP', false)
    },
    async setUsers () {
      this.usersList.forEach(async user => {
        if (user.checked) {
          if (!user.default) {
            try {
              await HTTP_CLIENT.post(`user/${user._id}/groupAbility/${this.role._id}`)
            } catch (error) { console.log(error) }
          }
        } else {
          if (user.default) {
            try {
              await HTTP_CLIENT.delete(`user/${user._id}/groupAbility/${this.role._id}`)
            } catch (error) { console.log(error) }
          }
        }
      })
      this.close()
      this.sendSuccessToast(this.$t('feedback-ok.groupAbility.setUsers', { name: this.role.name }))
    }
  }
}
</script>
